export const EMAIL_CATEGORY_COPY = {
  invoice: { label: "Invoice", heading: "Invoice email", description: "Customize the message sent with your invoice.", numberLabel: "Invoice number", sampleNumber: "INV-2157" },
  estimate: { label: "Estimate", heading: "Estimate email", description: "Customize the message sent with your estimate.", numberLabel: "Estimate number", sampleNumber: "EST-1042" },
} as const;

export type EmailTestAvailability = "available" | "verified_email_missing" | "verification_unavailable" | "environment_blocked" | "delivery_unavailable";
export interface EmailTestDestination { email: string | null; configured: boolean; reason: string | null; availability?: EmailTestAvailability }
export const EMAIL_TEST_COPY: Record<Exclude<EmailTestAvailability,"available">, string> = {
  verified_email_missing: "Verify an account email to send a test.",
  verification_unavailable: "We couldn’t verify your account email.",
  environment_blocked: "Test sending is blocked in this environment.",
  delivery_unavailable: "Test sending is unavailable right now.",
};
/** Compatibility with already served responses; never expose provider/configuration details. */
export function emailTestAvailability(destination: EmailTestDestination | null): EmailTestAvailability | null {
  if (!destination) return null;
  if (destination.availability && destination.availability !== "available") return destination.availability;
  if (destination.email && destination.configured) return "available";
  if (destination.email) return "delivery_unavailable";
  return destination.reason === "A verified account email is required." ? "verified_email_missing" : "verification_unavailable";
}
